import { SVGProps } from 'react'

const SvgPermissionAssignment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 7.875V6.3H6.125V7.875H0ZM0 4.725V3.15H9.625V4.725H0ZM0 1.575V0H9.625V1.575H0Z"
      fill="#5E5E5E"
    />
    <path
      d="M7.875 8.53125H11.8125V7.65625C11.8125 7.29167 11.6849 6.98177 11.4297 6.72656C11.1745 6.47135 10.8646 6.34375 10.5 6.34375C10.1354 6.34375 9.82552 6.47135 9.57031 6.72656C9.3151 6.98177 9.1875 7.29167 9.1875 7.65625H8.3125C8.3125 7.05104 8.52578 6.53516 8.95234 6.10859C9.37891 5.68203 9.89479 5.46875 10.5 5.46875C11.1052 5.46875 11.6211 5.68203 12.0477 6.10859C12.4742 6.53516 12.6875 7.05104 12.6875 7.65625V8.53125H13.125C13.3656 8.53125 13.5716 8.61693 13.743 8.78828C13.9143 8.95964 14 9.16562 14 9.40625V13.7812C14 14.0219 13.9143 14.2279 13.743 14.3992C13.5716 14.5706 13.3656 14.6562 13.125 14.6562H7.875C7.63437 14.6562 7.42839 14.5706 7.25703 14.3992C7.08568 14.2279 7 14.0219 7 13.7812V9.40625C7 9.16562 7.08568 8.95964 7.25703 8.78828C7.42839 8.61693 7.63437 8.53125 7.875 8.53125ZM7.875 13.7812H13.125V9.40625H7.875V13.7812ZM10.5 12.4688C10.7406 12.4688 10.9466 12.3831 11.118 12.2117C11.2893 12.0404 11.375 11.8344 11.375 11.5938C11.375 11.3531 11.2893 11.1471 11.118 10.9758C10.9466 10.8044 10.7406 10.7188 10.5 10.7188C10.2594 10.7188 10.0534 10.8044 9.88203 10.9758C9.71068 11.1471 9.625 11.3531 9.625 11.5938C9.625 11.8344 9.71068 12.0404 9.88203 12.2117C10.0534 12.3831 10.2594 12.4688 10.5 12.4688Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgPermissionAssignment
